var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowPinCodeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12H9.009M13 12H13.009M17 12H17.009M4.074 7.929C5.237 6.246 5.82 5.405 6.653 4.952C7.486 4.499 8.456 4.5 10.395 4.5H15.086C17.861 4.5 19.248 4.5 20.244 5.222C20.676 5.535 21.046 5.937 21.334 6.405C22 7.485 22 8.99 22 12C22 15.01 22 16.514 21.334 17.595C21.046 18.063 20.676 18.465 20.244 18.778C19.248 19.5 17.861 19.5 15.086 19.5H10.396C8.456 19.5 7.487 19.5 6.653 19.047C5.819 18.595 5.237 17.754 4.074 16.071L3.926 15.857C2.642 14 2 13.071 2 12C2 10.929 2.642 10 3.926 8.143L4.074 7.929Z",
    stroke: "#FF9500",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowPinCodeIcon);
export default __webpack_public_path__ + "static/media/YellowPinCodeIcon.56374fc69c87dba1c76a7ae252305665.svg";
export { ForwardRef as ReactComponent };